import cn from 'classnames';

import type { SortDirection } from './useEntityTableData';

type Props = {
  columnId: string;
  label: string;
  onSort: (columnId: string, direction: SortDirection) => void;
  sortable?: boolean;
  sortState: { columnId: string; direction: SortDirection } | null;
};

/** Column header with the same markup/classes as TaptapList's column, so it inherits its styles. */
export function SortHeader({ columnId, label, onSort, sortable = false, sortState }: Readonly<Props>) {
  const isActive = sortable && sortState?.columnId === columnId;

  const sortArrow = (direction: SortDirection) => (
    <button
      className={cn('taptapListColumnsBarColumn__sortArrow', {
        'taptapListColumnsBarColumn__sortArrow--active': isActive && sortState?.direction === direction
      })}
      onClick={() => onSort(columnId, direction)}
      type="button"
    >
      <i className={direction === 'asc' ? 'fa-solid fa-caret-up' : 'fa-solid fa-caret-down'} />
    </button>
  );

  return (
    <div className={cn('taptapListColumnsBarColumn', { 'taptapListColumnsBarColumn--active': isActive })}>
      <div className="taptapListColumnsBarColumn__description">
        <span className="taptapListColumnsBarColumn__labelGroup">
          <span className="taptapListColumnsBarColumn__descriptionText" title={label}>
            {label}
          </span>
          {sortable ? (
            <span className="taptapListColumnsBarColumn__sortArrows">
              {sortArrow('asc')}
              {sortArrow('desc')}
            </span>
          ) : null}
        </span>
      </div>
    </div>
  );
}
